import React from 'react'
import MyNavbar from './MyNavbar'
import Banner from './Banner'
import WriterProfileCard from './WriterProfileCard'

export default function Header() {
  return (
    <div>
        <MyNavbar/>
        <Banner/>
    </div>
  )
}
